import React, { Fragment } from 'react';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

// Storybook reference: https://ui-standard.hackhub.com/?path=/story/event-styleguide-paginations--paginations

const PaginationContainer = styled.div`
    display: inline-block;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    padding: 0.23m 0.4em;
    color: #06152B;
    padding: 0.2em 0.4em;
    margin: 0.1em;
    width:fit-content;

    i {
      cursor: pointer;
    }
`;
//  visibility: ${(props) => (props.toShow ? 'visible' : 'hidden')}
const StepContainer = styled(PaginationContainer)`
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    cursor: pointer; 
    color: #0094FB;

    i {
      color: #0094FB;        
    }
`;

const PrevIconWrapper = styled.span`
&&  {
  i {
    color:#809FB8;
    width: 30px;
    cursor: pointer;
    display: ${(props) => (props.firstPage ? 'none' : 'inline-block')}
  }
}
`;

const NextIconWrapper = styled(PrevIconWrapper)`
&& {
  i {
    display: ${(props) => (props.lastPage ? 'none' : 'inline-block')}
  }
}
`;

const ConsulContainer = styled(StepContainer)`
    font-size: 20px;
    line-height: 24px;
`;

export const ListPagination = ({ currentPage, totalPageCount, backClickEvent, nextClickEvent, ch }) => (
  <PaginationContainer>
    <PrevIconWrapper firstPage={currentPage === 1} >
      <Icon name='chevron left' onClick={backClickEvent} />
    </PrevIconWrapper>
    {
             ch ? `第 ${currentPage} 页 / 共 ${totalPageCount} 页 ` : `Page ${currentPage} of ${totalPageCount}`
        }
    <NextIconWrapper lastPage={currentPage === totalPageCount}>
      <Icon
        name='chevron right' onClick={nextClickEvent}
      />
    </NextIconWrapper>
  </PaginationContainer>
);


export const Pagination = ({
  currentPage, totalPageCount, nextStep, consultation, ch, onPageChange
}) => {
  if ((currentPage === 0 || currentPage) && totalPageCount) {
    return (
      <PaginationContainer>
        <PrevIconWrapper firstPage={currentPage === 0}>
          <Icon name='chevron left' onClick={() => onPageChange({ selected: (currentPage - 1) > 0 ? (currentPage - 1) : 0 })} />
        </PrevIconWrapper>
        {
             ch ? `第 ${currentPage + 1} 页 / 共 ${totalPageCount} 页 ` : `Page ${currentPage + 1} of ${totalPageCount}`
        }
        <NextIconWrapper lastPage={(currentPage + 1) === totalPageCount}>
          <Icon name='chevron right' onClick={() => onPageChange({ selected: (currentPage + 1) <= totalPageCount ? currentPage + 1 : totalPageCount - 1 })} />

        </NextIconWrapper>
      </PaginationContainer>
    );
  }

  if (consultation) {
    return (
      <ConsulContainer>
        {
            ch ? '免费咨询' : 'Get Free Consultation'
        }
        <Icon name='chevron right' />
      </ConsulContainer>
    );
  }

  return (
    <Fragment>
      {
        nextStep ? (
          <StepContainer>
            {
              ch ? '以后再做' : 'I will do this later'
            }
            <Icon name='chevron right' />
          </StepContainer>
        ) : (
          <StepContainer>
            <Icon name='chevron left' />
            {
                ch ? '后退' : 'Back'
            }
          </StepContainer>
        )
        }
    </Fragment>
  );
};

Pagination.defaultProps = {
  ch: false
};



// WEBPACK FOOTER //
// ./src/uiStandard/event/pagination.js